import React, { useEffect, useReducer, useState } from "react";
import { Dialog } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { PreDialogHeader } from "./preDialogHeader";
import "./style.css";
import { FormButton } from "../form/button";
import { preaddStyles } from "./styles";
import { AddSchoolForm } from "./addSchoolForm";
import { validateAddSchoolForm, validString } from "../../util/validation";
import { useDispatch, useSelector } from "react-redux";
import { setAlert } from "../../redux/reducers/alert";
import { addSchool, editSchool } from "../../api/schools";
import { BLUE_EIGHT, ORANGE_TWO, WHITE } from "../../theme";

export const AddSchoolDialog = ({
  open,
  handleClose,
  title,
  successCallback,
  isEditedItem,
}) => {
  const classes = preaddStyles();
  const { t } = useTranslation();
  let local = JSON.parse(localStorage.getItem("notify"));
  local = local || [];
  const [
    {
      name,
      address,
      description,
      vat,
      paynestFee,
      merchantId,
      file,
      payeeType
    },
    setData,
  ] = useReducer((state, newState) => ({ ...state, ...newState }), {
    name: "",
    address: "",
    description: "",
    vat: 2.5,
    paynestFee: 50,
    merchantId: "",
    file: "",
    payeeType: "STUDENT"
  });
  const [errors, setErrors] = useState([]);
  const [loading, setLoading] = useState(false);
  const { token } = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const handleChange = (prop) => (event) => {
    setData({
      [prop]: event.target.value,
    });

    if (errors.indexOf(prop) > -1) {
      const updatedErrors = [...errors];
      updatedErrors.splice(errors.indexOf(prop), 1);
      setErrors(updatedErrors);
    }
    // if ((prop === 'name' || prop === 'address')) {

    //   if (event.target.value === '') {
    //     if (prop === 'address') {
    //       if ((event.target.value).length) {
    //         setData({
    //           [prop]: event.target.value,
    //           nameError: false,
    //           addressError: false,
    //           descriptionError: false,
    //           vatError: false,
    //           paynestFeeError: false,
    //           merchantIdError: false,
    //           file: file
    //         });
    //       }
    //     }

    //     if (prop === 'name') {
    //       if ((event.target.value).length) {
    //         setData({
    //           [prop]: event.target.value,
    //           nameError: false,
    //           addressError: false,
    //           descriptionError: false,
    //           vatError: false,
    //           paynestFeeError: false,
    //           merchantIdError: false,
    //           file: file
    //         });
    //       }
    //     }

    //   }
    // } else if (prop === 'description') {
    //   if ((event.target.value).length) {
    //     setData({
    //       [prop]: event.target.value,
    //       nameError: false,
    //       addressError: false,
    //       descriptionError: false,
    //       vatError: false,
    //       paynestFeeError: false,
    //       merchantIdError: false,
    //       file: file
    //     });
    //   }
    // } else if (prop === 'merchantId') {

    //   if ((event.target.value).length) {
    //     setData({
    //       [prop]: event.target.value,
    //       nameError: false,
    //       addressError: false,
    //       descriptionError: false,
    //       vatError: false,
    //       paynestFeeError: false,
    //       merchantIdError: false,
    //       file: file
    //     });
    //   }

    // } else if (prop === 'vat' || prop === 'paynestFee') {
    //   if (event.target.value >= 0) {
    //     setData({
    //       [prop]: event.target.value,
    //       nameError: false,
    //       addressError: false,
    //       descriptionError: false,
    //       vatError: false,
    //       paynestFeeError: false,
    //       merchantIdError: false,
    //       file: file
    //     });
    //   }
    // } else {
    //   setData({
    //     [prop]: event.target.value,
    //     nameError: false,
    //     addressError: false,
    //     descriptionError: false,
    //     vatError: false,
    //     paynestFeeError: false,
    //     merchantIdError: false,
    //     file: file
    //   });
    // }

  };

  useEffect(() => {
    if (isEditedItem) {
      setData({
        name: isEditedItem.name,
        address: isEditedItem.address,
        description: isEditedItem.description,
        paynestFee: isEditedItem.paynestFee ? isEditedItem.paynestFee : 0,
        vat: isEditedItem.vat ? isEditedItem.vat : 0,
        merchantId: isEditedItem.merchantId,
        file: isEditedItem.file,
        payeeType: isEditedItem.payeeType || "",
      });
    }
  }, [isEditedItem]);

  const showErrorAlert = (message) => {
    dispatch(
      setAlert({
        severity: "error",
        message,
        show: true,
      })
    );
  };

  const showSuccessAlert = (message) => {
    dispatch(
      setAlert({
        severity: "success",
        message,
        show: true,
      })
    );
  };

  const resetData = () => {
    setData({
      name: "",
      address: "",
      description: "",
      vat: 2.5,
      paynestFee: 50,
      merchantId: "",
      file: "",
      payeeType: "",
    });
  };

  const addSchoolHandler = async () => {
    const validationResponse = validateAddSchoolForm(
      name,
      address,
      merchantId,
      payeeType
    );

    if (validationResponse.length > 0) {
      setErrors(validationResponse);
      return;
    }
    try {
      setLoading(true);
      const payload = {
        paynestFee,
        vat,
        name,
        address,
        description,
        merchantId,
        file,
        payeeType
      };


      const id = await addSchool(payload, token);
      if (id) {
        showSuccessAlert(t("text_school_added_successfully"));
        local.push({
          message: t("text_school_added_successfully"),
          date: new Date().getTime(),
          newNotification: true,
        });
        localStorage.setItem("notify", JSON.stringify(local));
        resetData();
        successCallback();
      } else {
        showErrorAlert(t("text_error_in_adding_school_please_try_again"));

      }
    } catch (error) {
    }
  };

  const editSchoolHandler = async () => {
    const validationResponse = validateAddSchoolForm(
      name,
      address,
      merchantId
    );

    if (validationResponse.length > 0) {
      setErrors(validationResponse);
      return;
    }
    try {
      setLoading(true);
      const payload = {
        paynestFee,
        vat,
        name,
        address,
        description,
        merchantId,
        file,
        payeeType
      };

      const response = await editSchool(payload, isEditedItem.id, token);
      if (response?.status) {
        showSuccessAlert(t("text_school_updated_successfully"));
        local.push({
          message: t("text_school_updated_successfully"),
          date: new Date().getTime(),
          newNotification: true,
        });
        localStorage.setItem("notify", JSON.stringify(local));
        successCallback();
        resetData();
      } else {
        showErrorAlert(t("text_error_in_updating_school_please_try_again"));
      }
      setLoading(false);
    } catch (err) {
      setLoading(false);
      showErrorAlert(
        err.message || t("text_error_in_updating_school_please_try_again")
      );
    }
  };

  const close = () => {
    resetData();
    handleClose();
  };

  return (
    <Dialog
      className={classes.root}
      onClose={handleClose}
      aria-labelledby="simple-dialog-title"
      open={open}
    >
      <div className={classes.mainContainer}>
        <PreDialogHeader backbut={true} title={title} handleClose={handleClose} />
        {/* <div style={{ marginTop: "30px", display: "flex", justifyContent: "center" }}>
          <div
            style={{
              float: "left",
              paddingLeft: "26px",
            }}
          >
            <div className="setting_img">
              {
                base64 ?
                  <img src={base64} alt="" />
                  : file ?
                    <img src={`${file}`} alt="" />
                    : <Avatar />
              }
            </div>
          </div>
          <div
            style={{
              float: "left",
              marginTop: "60px",
              marginLeft: "-20px",
            }}
          >
            <label htmlFor="icon-button-file" className="cam_button">
              <Input
                accept="image/*"
                id="icon-button-file"
                type="file"
                onChange={onGetFile}
                name="file"
                style={{ display: 'none' }}
              />
              <IconButton
                color="primary"
                aria-label="upload picture"
                component="span"
              >
                <PhotoCem />
              </IconButton>
            </label>
          </div>
        </div> */}


        <div className={classes.dropContainer}>
          <AddSchoolForm
            name={name}
            address={address}
            description={description}
            vat={vat}
            paynestFee={paynestFee}
            errors={errors}
            handleChange={handleChange}
            merchantId={merchantId}
            payeeType={payeeType}
          />
        </div>

        <div className={classes.addSchooldialogFooter}>
          <div className={classes.footerButton}>
            <FormButton
              title={t("text_cancel")}
              borderColor={ORANGE_TWO}
              titleColor={WHITE}
              hoverTitleColor={ORANGE_TWO}
              hoverBorderColor={ORANGE_TWO}
              backgroundColor={ORANGE_TWO}
              hoverBackgroundColor={WHITE}
              onClickHandler={close}
              height={40}
              width={"10vw"}
              borderTopRightRadius={15}
              borderTopLeftRadius={15}
              borderBottomLeftRadius={15}
              borderBottomRightRadius={15}
              style={{ textTransform: "none", fontSize: "0.8vw", fontWeight: "700" }}
            />
          </div>

          <div className={classes.footerButton}>
            <FormButton
              loading={loading}
              borderColor={BLUE_EIGHT}
              titleColor={BLUE_EIGHT}
              hoverTitleColor={WHITE}
              hoverBorderColor={BLUE_EIGHT}
              backgroundColor={WHITE}
              hoverBackgroundColor={BLUE_EIGHT}
              style={{ textTransform: "none", fontSize: "0.8vw", fontWeight: "700", padding: 0 }}
              title={t("text_continue")}
              onClickHandler={
                isEditedItem ? editSchoolHandler : addSchoolHandler
              }
              height={40}
              width={"10vw"}
              borderTopRightRadius={15}
              borderTopLeftRadius={15}
              borderBottomLeftRadius={15}
              borderBottomRightRadius={15}
            />
          </div>
        </div>
      </div>
    </Dialog>
  );
};
